import { Game } from '../../types';
import type { OdinModuleId } from '../../data/a-feast-for-odin';

export const ODIN_GAME_ID = 'uczta-dla-odyna';

export type OdinPlayerCount = 1 | 2 | 3 | 4;

export type OdinGameConfiguration = {
  playerCount: OdinPlayerCount;
  /** Optional expansion — default true */
  norwegians: boolean;
  /** Always 7 for first game / standard play in this app */
  rounds: 7;
  configured: boolean;
};

export type OdinReadingProgress = {
  readChapterIds: string[];
  lastChapterId: string | null;
  lastSectionId: string | null;
  scrollOffsets: Record<string, number>;
};

export type OdinTutorialProgress = {
  currentStepId: string;
  completedStepIds: string[];
};

export type OdinGameListing = Game & {
  shortTitle: string;
};

export type { OdinModuleId };
